import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Typography,
  Autocomplete,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers";
import React from "react";

interface AddCreditModalProps {
  open: boolean;
  handleClose: () => void;
  formData: {
    date: Date | null;
    client_id: number | null;
    nbrLines: string;
  };
  setFormData: React.Dispatch<
    React.SetStateAction<{
      date: Date | null;
      client_id: number | null;
      nbrLines: string;
    }>
  >;
  onAddCredit: () => void;
  clients: any[];
}

export const AddCreditModal: React.FC<AddCreditModalProps> = ({
  open,
  handleClose,
  formData,
  setFormData,
  onAddCredit,
  clients,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onAddCredit();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "500px",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 2,
        }}
      >
        <Typography variant="h6">Add New Credit</Typography>
        <IconButton onClick={handleClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Stack spacing={3}>
            <DatePicker
              label="Date"
              value={formData.date}
              onChange={(newValue) =>
                setFormData((prev) => ({ ...prev, date: newValue }))
              }
              slotProps={{
                textField: {
                  fullWidth: true,
                  required: true,
                },
              }}
            />

            <TextField
              label="Number of credits"
              type="number"
              value={formData.nbrLines}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, nbrLines: e.target.value }))
              }
              required
              fullWidth
            />
          </Stack>
        </DialogContent>

        <DialogActions sx={{ p: 2.5 }}>
          <Button onClick={handleClose} color="inherit">
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={!formData.date}
          >
            Add Credit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
